export default "__VITE_ASSET__Bzmh0cCX__"